/* unplugin-vue-components disabled */import script from "./Balance.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance.vue?vue&type=script&setup=true&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=028d00d8&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-swan-h5-game/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028d00d8"]])

export default __exports__